export default "__VITE_ASSET__CwazxgrE__"